module.exports = __webpack_public_path__ + "static/media/image_step3.d30e853c.png";